/**
 * @copyright (C) 2024, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * SoonKi Min (skmin@rsupport.com)
 *
 * @description
 *
 * @created at Mon May 13 2024
 **/

import { useState } from "react";

import { ModalPopup, TextField, useModal, useToast } from "@/frameworks/designStuff/components";
import { Utility } from "@/frameworks/libraries/utilities";
import { _T } from "@rfice/language";

interface LinkPopupProps {
	modalID: string;
	onConfirm: (link: string) => void;
}

export default function LinkPopup(props: LinkPopupProps) {
	const [link, setLink] = useState<string>("");
	const toast = useToast();

	const modalActions = useModal();

	const submit = (ev: React.MouseEvent | React.FormEvent<HTMLFormElement> | KeyboardEvent) => {
		ev.preventDefault();
		ev.stopPropagation();

		if (!Utility.isURL(link)) {
			toast.show({ type: "error", message: _T("올바르지 않은 URL 입니다."), closeButton: true });
			setLink("");
		} else {
			props.onConfirm(link);
			modalActions.hide(props.modalID);
		}
	};

	return (
		<ModalPopup
			modalID={props.modalID}
			title={_T("링크를 입력해주세요")}
			confirmText={_T("확인")}
			cancelText={_T("취소")}
			onConfirm={submit}
		>
			<form onSubmit={submit} css={{ width: "100%" }}>
				<TextField
					autoFocus
					value={link}
					onChange={(ev) => {
						setLink(ev.target.value);
					}}
				/>
			</form>
		</ModalPopup>
	);
}
